export default function Footer() {
  return (
    <footer className="border-t border-[#e3d7bd] bg-[#eadfc7]">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <p className="font-display text-3xl font-black tracking-[0.08em] text-[#1a160e]">
              呱呱黑料
            </p>
            <p className="mt-3 max-w-sm text-sm leading-6 text-[#6f6552]">
              一份慢慢翻的历史旧账刊：整理早年言论、陈年往事与黑历史后续，
              用考古发现的耐心，把每一段旧账都摊开对清楚。
            </p>
            <p className="mt-4 text-[11px] tracking-widest text-[#978a72]">
              单页静态展示 · 无真实检索与下载
            </p>
          </div>

          <div>
            <p className="text-[11px] tracking-[0.3em] text-[#852f12]">翻旧账栏目</p>
            <ul className="mt-4 space-y-2 text-sm text-[#6f6552]">
              <li><a href="#today" className="transition hover:text-[#1a160e]">今日新账 · 快讯流</a></li>
              <li><a href="#timeline" className="transition hover:text-[#1a160e]">呱呱黑料考古时间线</a></li>
              <li><a href="#quotes" className="transition hover:text-[#1a160e]">早年言论语录卷</a></li>
              <li><a href="#topics" className="transition hover:text-[#1a160e]">旧账卷宗分卷</a></li>
            </ul>
          </div>

          <div>
            <p className="text-[11px] tracking-[0.3em] text-[#852f12]">关于与入口</p>
            <ul className="mt-4 space-y-2 text-sm text-[#6f6552]">
              <li><a href="#dossier" className="transition hover:text-[#1a160e]">深度旧账专题</a></li>
              <li><a href="#download" className="transition hover:text-[#1a160e]">下载呱呱黑料离线卷</a></li>
              <li><a href="#about" className="transition hover:text-[#1a160e]">阅读约定与纠错</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-[#e3d7bd] pt-6 text-[11px] text-[#978a72] sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 呱呱黑料 · 虚构归档展示，本站内容均不指向真实人物与事件。</p>
          <p className="flex items-center gap-2">
            <i className="ri-error-warning-line" aria-hidden="true"></i>
            请理性浏览，勿将内容用作现实指涉
          </p>
        </div>
      </div>
    </footer>
  );
}